// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"5849e485","73":"a027af43","180":"7c580bfb","233":"80e68335","365":"63424b37","395":"a5f4974d","647":"6abf695c","787":"ccb1d6ba","875":"7736f296"}[chunkId] + ".chunk.js";
};